<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <b-col lg="12" sm="12">
                        <b-form-row>
                            <b-col lg="8" sm="8">
                                <b-col lg="12" sm="12" class="text-left">

                                    <LgFinderPagePessoa :mostrarComissao="true" :prefix="prefix + title + ' > '"
                                        id="finderResponsavel" label="Responsável:" @onselect="handleSelectResponsavel"
                                        v-model="form.pessoaComissao" @onselectComissao="handleSelectComissao"
                                        invalidFeedback="Informe um responsável!" />
                                </b-col>
                                <b-col lg="12" sm="12" class="text-left">
                                    <LgFinderPageUnidadeAdministrativa :prefix="prefix + title + ' > '"
                                        id="finderUnidadeAdministrativa" label="Unidade Administrativa:"
                                        @onselect="handleSelectUnidadeAdministrativa" v-model="form.departamento"
                                        invalidFeedback="Informe uma unidade administrativa!" />
                                </b-col>
                                <b-col lg="12" sm="12" class="text-left">
                                    <LgFinderPageLocalArmazenamento :prefix="prefix + title + ' > '"
                                        id="finderLocalArmazenamentoInventario" label="Localização Física:"
                                        @input="handleSelectLocalArmazenamento" @close="handleSelectLocalArmazenamento"
                                        v-model="form.localizacao" :departamento="form.departamento"
                                        invalidFeedback="Informe uma localização física!" />
                                    <b-form-row>
                                        <b-col lg="8" sm="8" class="d-flex align-items-center">
                                            <b-row>
                                                <b-col lg="6" sm="6">
                                                    <LgFormDate v-model="form.dataDe" label="De:" description=""
                                                        invalidFeedback="Informe a data inicial!" />
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <LgFormDate v-model="form.dataAte" label="Até:" description=""
                                                        invalidFeedback="Informe a data final!" />
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col lg="4" sm="4">
                                            <b-form-group label="Status:">
                                                <b-form-select @input="load" v-model="form.status" size="sm"
                                                    class="w-auto select-compact">
                                                    <option :value="null">Todos</option>
                                                    <option value="aberto">Abertos</option>
                                                    <option value="finalizado">Finalizados</option>
                                                </b-form-select>
                                            </b-form-group>
                                        </b-col>
                                    </b-form-row>
                                </b-col>
                            </b-col>
                            <b-col lg="4" sm="4" class="d-flex align-items-center justify-content-center">

                                <b-button id="limpar" class="my-2" size="sm" style="height: 20px" pill variant="primary"
                                    @click="clearForm">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="eraser" />
                                    </div>
                                    <b-tooltip target="limpar" title="Limpar"></b-tooltip>
                                </b-button>

                                <b-button id="localizar" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
                                    variant="primary" @click="load">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="search" />
                                    </div>
                                    <b-tooltip target="localizar" title="Localizar"></b-tooltip>
                                </b-button>

                                <b-button v-if="temPrivilegioInclusao()" id="novo" class="ml-3 mr-2 my-2"
                                    style="height: 20px" @click="openCreateModal" size="sm" pill variant="secondary">
                                    <div class="btn-size-alinhamento">
                                        <b-icon scale="1" icon="plus" />
                                    </div>
                                    <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>
                                </b-button>


                            </b-col>
                        </b-form-row>
                    </b-col>
                </b-form-row>
            </b-card>

            <b-card bg-variant="light">
                <b-table :items="records" :fields="tableFields" :busy="busy" responsive small hover show-empty>


                    <template #cell(data)="row">
                        {{ formatDate(row.item.dataAuditoria) }}
                    </template>

                    <template #cell(dadosColetadosAnalise)="row">
                        <img v-b-tooltip.hover.bottom="{ title: 'Relatório de Análise dos Dados Coletados no Inventário', customClass: 'inventario-tooltip', container: 'body', boundary: 'window' }"
                            @click="gerarPdf(row.item)" :src="pdf" class="img" alt="PDF"
                            style=" width: 25px; height:25px; cursor: pointer;" />
                    </template>


                    <template #cell(dadosColetados)="row">
                        <img v-b-tooltip.hover.bottom="{ title: 'Relatório de Dados coletados no Inventário', customClass: 'inventario-tooltip', container: 'body', boundary: 'window' }"
                            @click="gerarPdfCarga(row.item)" :src="pdf" class="img" alt="PDF"
                            style=" width: 25px; height:25px; cursor: pointer;" />
                    </template>


                    <template #cell(responsavel)="row">
                        {{ row.item.pessoa && row.item.pessoa.nome ? row.item.pessoa.nome : (row.item.comissao &&
                            row.item.comissao.descricao ? row.item.comissao.descricao:'') }}
                    </template>
                    <template #cell(unidadeAdministrativa)="row">
                        {{ row.item.departamento.descricao }}
                    </template>

                    <template #cell(localizacao)="row">
                        {{ row.item.localizacao && row.item.localizacao.descricao ? row.item.localizacao.descricao : ''
                        }}
                    </template>

                    <template #cell(processoManual)="row">
                        <b-badge :variant="row.item.processoManual ? 'success' : 'danger'">
                            {{ row.item.processoManual ? 'Sim' : 'Não' }}
                        </b-badge>
                    </template>

                    <template #cell(acoes)="row">
                        <b-button-group v-if="!row.item.finalizado">
                            <b-button v-b-tooltip.hover.bottom="{ title: 'Continuar inventário', customClass: 'inventario-tooltip', container: 'body', boundary: 'window' }"
                                :disabled="!temPrivilegioEdicao()" variant="primary" size="sm"
                                @click="continuarInventario(row.item)">
                                <b-icon icon="pencil-square" />
                            </b-button>

                            <b-button v-b-tooltip.hover.bottom="{ title: 'Finalizar inventário', customClass: 'inventario-tooltip', container: 'body', boundary: 'window' }"
                                :disabled="!temPrivilegioEdicao()" variant="primary" size="sm" class="mr-2 ml-2"
                                @click="finalizarInventario(row.item)">
                                <b-icon icon="check-circle" />
                            </b-button>

                            <b-button v-b-tooltip.hover.bottom="{ title: 'Remover inventário', customClass: 'inventario-tooltip', container: 'body', boundary: 'window' }"
                                :disabled="!temPrivilegioExclusao()" variant="primary" size="sm"
                                @click="removerInventario(row.item)">
                                <b-icon icon="trash" />
                            </b-button>
                        </b-button-group>
                    </template>

                    <template #empty>
                        <p class="text-center">Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle" />
                        </div>
                    </template>
                </b-table>

                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                            totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>

            <InventarioItemBemPermanenteForm :auditoria="auditoria" v-if="showModal" :prefix="prefix + title + ' > '"
                @refreshList="load" @close="fecharModal" />
        </b-card-body>
    </b-card>
</template>

<script>
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import { VBTooltip } from "bootstrap-vue";
import AuditoriaItemBemPermanenteService from "@/core/api/AuditoriaItemBemPermanenteService.js";
import InventarioItemBemPermanenteForm from "./InventarioItemBemPermanenteForm.vue";
import moment from "moment";
import Swal from "sweetalert2";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import PdfIcon from "@/core/assets/icons/pdf.png";
import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil"
import ResourceService from "@/core/api/ResourceService"


export default {
    directives: {
        "b-tooltip": VBTooltip,
    },
    components: {
        LgFinderPagePessoa,
        LgFinderPageUnidadeAdministrativa,
        LgFinderPageLocalArmazenamento,
        LgFormDate,
        InventarioItemBemPermanenteForm
    },
    props: {
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Inventário Item Bem Permanente"
        }
    },
    data() {

        return {
            pdf: PdfIcon,
            auditoria: {},
            showModal: false,
            busy: false,
            page: 1,
            perPage: 10,
            totalPage: 1,
            total: 0,
            records: [],
            form: {
                pessoaComissao: null,
                comissao: null,
                responsavel: null,
                departamento: null,
                localizacao: null,
                dataDe: "",
                dataAte: "",
                status: null,
            },

            tableFields: [
                { key: "data", label: "Data da Auditoria" },
                { key: "responsavel", label: "Responsável" },
                { key: "unidadeAdministrativa", label: "Unidade Administrativa" },
                { key: "localizacao", label: "Localização Física" },
                { key: "processoManual", label: "Processo Manual" },
                {
                    key: "idSolicitacaoInventario",
                    label: "Solicitação",
                },

                { key: "acoes", label: " ", tdClass: "text-center", thClass: "text-center" },
                { key: "dadosColetadosAnalise", label: " ", tdClass: "text-center", thClass: "text-center" },
                { key: "dadosColetados", label: " ", tdClass: "text-center", thClass: "text-center" },
            ],
        };
    },
    watch: {
        page() {
            this.load();
        },
    },

    methods: {
        async gerarPdfCarga(item){
           this.busy = true;
            var { data } = await new ResourceService(`/api/relatorio/gerar-relatorio-carga-patrimonial`).get(`PDF/${item.id}`);
            DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            this.busy = false;

        },
        async gerarPdf(item) {
            this.busy = true;
            var { data } = await new ResourceService(`/api/relatorio/gerar-relatorio-dados-coletados-inventario`).get(`PDF/${item.id}`);
            DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            this.busy = false;

        },
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.AUDIT_BEM_PERMANENTE_EDITAR);

        },
        temPrivilegioInclusao() {
            return verificaPrivilegio(PrivilegiosEnum.AUDIT_BEM_PERMANENTE_INCLUIR);

        },
        temPrivilegioExclusao() {
            return verificaPrivilegio(PrivilegiosEnum.AUDIT_BEM_PERMANENTE_EXCLUIR);

        },

        formatDate(date) {
            return moment(date).format("DD/MM/YYYY");
        },

        handleSelectResponsavel(responsavel) {
            this.form.pessoaComissao = responsavel;
            this.form.responsavel = responsavel;
            this.form.comissao = null;
            this.load()
        },
        handleSelectComissao(comissao) {
            this.form.pessoaComissao = comissao;
            this.form.comissao = comissao;
            this.form.responsavel = null;

            this.load()
        },
        handleSelectUnidadeAdministrativa(departamento) {
            this.form.departamento = departamento;
            this.load()
        },
        handleSelectLocalArmazenamento(localizacao) {
            this.form.localizacao = localizacao;
            this.load()
        },
        clearForm() {
            this.form = {
                pessoaComissao: null,
                comissao: null,
                responsavel: null,
                departamento: null,
                localizacao: null,
                dataDe: "",
                dataAte: "",
                status: null,
            };
            this.load();
        },
        async load() {
            this.busy = true;


            const params = {
                codComissao: this.form.comissao ? this.form.comissao.id : undefined,
                codPessoa: this.form.responsavel ? this.form.responsavel.id : undefined,
                codDepartamento: this.form.departamento ? this.form.departamento.id : undefined,
                codLocalizacao: this.form.localizacao ? this.form.localizacao.id : undefined,
                dataDe: this.form.dataDe ? moment(this.form.dataDe).format('YYYY-MM-DD') : undefined,
                dataAte: this.form.dataAte ? moment(this.form.dataAte).format('YYYY-MM-DD') : undefined,
                finalizado: this.form.status === "finalizado" ? true : this.form.status === "aberto" ? false : null,
                page: this.page - 1,
                size: this.perPage,
            };
            const response = await AuditoriaItemBemPermanenteService.listarAuditorias(params);
            const content = Array.isArray(response.data.content) ? response.data.content : [];
            this.records = content.slice().sort((a, b) => {
                const dateA = a && a.dataAuditoria ? new Date(a.dataAuditoria).getTime() : 0;
                const dateB = b && b.dataAuditoria ? new Date(b.dataAuditoria).getTime() : 0;
                return dateB - dateA;
            });
            this.total = response.data.totalElements;
            this.totalPage = response.data.totalPages;
            this.busy = false;
        },
        async continuarInventario(item) {
            this.showModal = true;
            this.auditoria = item;
        },
        async finalizarInventario(item) {
            Swal.fire({
                title: "Você tem certeza?",
                text: "Deseja finalizar este inventário? Esta ação não pode ser desfeita.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, finalizar!",
                cancelButtonText: "Cancelar",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await AuditoriaItemBemPermanenteService.finalizarAuditoria(item.id);
                        Swal.fire("Finalizado!", "O inventário foi finalizado com sucesso.", "success");
                        this.load();
                    } catch (error) {
                        Swal.fire("Erro", "Ocorreu um erro ao finalizar o inventário.", "error");
                    }
                }
            });
        },
        async removerInventario(item) {
            Swal.fire({
                title: "Você tem certeza?",
                text: "Deseja remover este inventário? Esta ação não pode ser desfeita.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, remover!",
                cancelButtonText: "Cancelar",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await AuditoriaItemBemPermanenteService.removerAuditoria(item.id);
                        Swal.fire("Removido!", "O inventário foi removido com sucesso.", "success");
                        this.load();
                    } catch (error) {
                        Swal.fire("Erro", "Ocorreu um erro ao remover o inventário.", "error");
                    }
                }
            });
        },
        fecharModal() {
            this.showModal = false;
            this.load();
        },
        openCreateModal() {
            this.auditoria = {};
            this.showModal = true;
        },
    },
    mounted() {
        this.load();
    },
};
</script>

<style scoped>
.btn-input-finder {
    padding: 0 8px;
    height: 28px;
}

.inventario-tooltip .tooltip-inner {
    max-width: 220px;
    white-space: normal;
    text-align: center;
}
</style>
